<template>
  <div class="login-container">
    <img class="login-watermark" src="/images/logo.png" alt="" aria-hidden="true" />
    <div class="login-card">
      <div class="login-header">
        <img src="/images/logo.png" alt="国测检测" class="brand-logo" />
        <h2>国测检测 · 检验报告管理系统</h2>
        <p>请登录以继续使用</p>
      </div>
      
      <el-form 
        ref="loginForm" 
        :model="loginData" 
        :rules="rules" 
        class="login-form"
        @submit.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginData.username"
            placeholder="请输入用户名"
            prefix-icon="User"
            size="large"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="Lock"
            size="large"
            show-password
            @keyup.enter="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            size="large" 
            class="login-button"
            :loading="loading"
            @click="handleLogin"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      
      <!-- <div class="login-tips">
        <p>默认账号：admin</p>
        <p>默认密码：admin123</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const loading = ref(false)
    
    const loginData = reactive({
      username: '',
      password: ''
    })
    
    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
      ]
    }
    
    const loginForm = ref(null)
    
    const handleLogin = async () => {
      if (!loginForm.value) return
      
      try {
        await loginForm.value.validate()
        loading.value = true
        
        // 模拟登录延迟
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        // 静态账号密码验证
        if (loginData.username === 'GC' && loginData.password === '18656600255.') {
          // 保存登录状态到localStorage
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('username', loginData.username)
          localStorage.setItem('loginTime', new Date().toISOString())
          
          ElMessage.success('登录成功！')
          
          // 跳转到报告列表页
          router.push('/ReportList')
        } else {
          ElMessage.error('用户名或密码错误！')
        }
      } catch (error) {
        console.error('登录验证失败:', error)
      } finally {
        loading.value = false
      }
    }
    
    return {
      loginData,
      rules,
      loading,
      loginForm,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ffffff 0%, #f6f0ff 50%, #0068b7 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-watermark {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 420px;
  height: auto;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}

.brand-logo {
  width: 56px;
  height: 56px;
  object-fit: contain;
  margin-bottom: 12px;
}

.login-header h2 {
  color: #0068b7;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
}

.login-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-form {
  margin-bottom: 20px;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

.login-button {
  width: 100%;
  height: 45px;
  font-size: 16px;
  font-weight: 500;
}

.login-tips {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  border-left: 4px solid #409eff;
}

.login-tips p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }
  
  .login-card {
    padding: 30px 20px;
  }
  
  .login-header h2 {
    font-size: 20px;
  }
}
</style>
